import { Phone, MapPin } from "lucide-react";

const LOGO = "https://customer-assets-v7afamib.emergentagent.net/job_deductible-to-done/artifacts/puragtdz_Copy%20of%20Herologo.PNG";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-hero-void border-t border-white/10 pt-24 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 mb-20">
          <div>
            <img
              src={LOGO}
              alt="Hero Exteriors"
              data-testid="footer-logo"
              className="h-24 w-auto mb-8 rounded-lg bg-white p-2 shadow-[0_0_40px_rgba(220,38,38,0.15)]"
            />
            <p className="text-xs uppercase tracking-[0.3em] text-hero-red mb-6">— Hero Exteriors</p>
            <p className="text-2xl md:text-3xl text-white/90 max-w-md leading-snug">
              Years of experience on every job. The only thing that&apos;s new is the roof we give you.
            </p>
            <div className="mt-6 inline-flex items-baseline gap-2" data-testid="years-experience">
              <span className="font-display text-5xl md:text-6xl text-hero-red leading-none">20+</span>
              <span className="uppercase tracking-wide text-hero-silver text-sm">years of<br />experience</span>
            </div>
          </div>
          <div className="flex flex-col gap-6 md:items-end justify-end">
            <a href="tel:4432509046" data-testid="footer-call" className="group inline-flex items-center gap-3 text-white hover:text-hero-red transition-colors duration-200">
              <Phone className="h-5 w-5 text-hero-red" />
              <span className="font-display text-3xl">443-250-9046</span>
            </a>
            <div className="flex items-start gap-3 text-hero-silver md:text-right">
              <MapPin className="h-5 w-5 text-hero-red shrink-0 mt-1" />
              <span>26 Heather Hill Road<br />Catonsville, Maryland 21228</span>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 pt-8 border-t border-white/10 text-sm text-hero-silver">
          <span>© {new Date().getFullYear()} Hero Exteriors. All rights reserved.</span>
          <span>Catonsville, MD • Roofing & Exterior Restoration</span>
        </div>
      </div>
    </footer>
  );
}
